import React from "react";
import {
   EMPLOYMENT_STATUS_OPTIONS,
   MARITAL_STATUS_OPTIONS,
   TITLE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";

import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {isEmployed} from "@functions/employments";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import {ValidateStep1Data} from "@validators/fast-food-delivery-insurance-form/step1-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step1(
   {
      data,
      handlers,
      setCurrentStep
   }
) {
   
   const STEP = 1;
   
   function onNextBtnClick() {
      
      let validationResult = ValidateStep1Data(data);
      
      /*validationResult.push({
          name : 'halt',
          message : 'Halt'
      });*/
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         })
         
         
      } else {
         setCurrentStep(STEP + 1);
      }
      
      
   }
   
   function onPrevBtnClick() {
      setCurrentStep(STEP - 1);
   }
   
   return (
      <div className={`if-step-${STEP}`}>
         
         <SectionHeading
            text="Personal Info"
         />
         
         <div className="row">
            
            {/* Title */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 extra"
               labelText="Title"
               required={true}
               controlName="title"
               options={TITLE_OPTIONS}
               selectedValues={data.title}
               onChange={handlers.onControlChange}
            />
         
         </div>
         
         
         <div className="row name-block">
            
            {/* First name */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="First name"
               required={true}
               controlName="firstName"
               value={data.firstName}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Last name */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Last name"
               required={true}
               controlName="lastName"
               value={data.lastName}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Date of birth */}
            
            <ScrollableCustomDateTimePickerBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Date of birth"
               required={true}
               controlName="birthDate"
               value={data.birthDate}
               onChange={handlers.onControlChange}
               useSplitDate={true}
            />
         
         
         </div>
         
         <div className="row address-block">
            
            {/* House number */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="House number"
               required={true}
               controlName="houseNumber"
               value={data.houseNumber}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Street address */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Street address"
               required={true}
               controlName="addressLine1"
               value={data.addressLine1}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Address line 2 */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Address line 2"
               required={false}
               controlName="addressLine2"
               value={data.addressLine2}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
         
         
         </div>
         
         <div className="row other-block">
            
            {/* Post code */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Post code"
               required={true}
               controlName="postCode"
               value={data.postCode}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 10
               }}
            />
            
            {/* Marital status */}
            
            <ScrollableDropdownBlock
               controlName="maritalStatus"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Marital status"
               required={true}
               options={MARITAL_STATUS_OPTIONS}
               selectedValues={data.maritalStatus}
               onChange={handlers.onControlChange}
               helpText=""
            />
            
            {/* Employment status */}
            
            <ScrollableDropdownBlock
               controlName="employmentStatus"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Employment status"
               required={true}
               options={EMPLOYMENT_STATUS_OPTIONS}
               selectedValues={data.employmentStatus}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         {isEmployed(data.employmentStatus) && (
            <div className="row pb-3 mb-3 hidden-box p-3">
               
               {/* Main Occupation */}
               
               <ScrollableTextBoxBlock
                  containerCssClass="col-12 py-3 col-md-6"
                  labelText="What's your main occupation?"
                  required={true}
                  controlName="mainOccupation"
                  value={data.mainOccupation}
                  onChange={handlers.onControlChange}
                  inputAttrs={{
                     maxLength: 50
                  }}
               />
               
               {/* Occupation Industry */}
               
               <ScrollableTextBoxBlock
                  containerCssClass="col-12 py-3 col-md-6"
                  labelText="What industry is this occupation in?"
                  required={true}
                  controlName="occupationIndustry"
                  value={data.occupationIndustry}
                  onChange={handlers.onControlChange}
                  asTextArea={false}
                  inputAttrs={{
                     maxLength: 50
                  }}
               />
            
            </div>
         )}
         
         <div className="row">
            
            {/* Home Owner? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3"
               labelText="Are you home owner?"
               required={true}
               controlName="isHomeOwner"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.isHomeOwner}
               onChange={handlers.onControlChange}
            />
            
            {/* Has children under 16? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3"
               labelText="Do you have children under 16 years old?"
               required={true}
               controlName="hasChildrenUnder16"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.hasChildrenUnder16}
               onChange={handlers.onControlChange}
            />
            
            {"Yes" === data.hasChildrenUnder16 && (
               <>
                  {/* How many? */}
                  
                  <ScrollableTextBoxBlock
                     containerCssClass="col-12 py-3 col-md-6"
                     labelText="How many?"
                     required={data.hasChildrenUnder16 === "Yes"}
                     controlName="numChildrenUnder16"
                     value={data.numChildrenUnder16}
                     onChange={handlers.onControlChange}
                     asTextArea={false}
                     inputAttrs={{
                        maxLength: 20
                     }}
                  />
               </>
            
            )}
            
            
            
         
         </div>
         
         <WizardStepButtonsBlock
            onPrevBtnClick={onPrevBtnClick}
            onNextBtnClick={onNextBtnClick}
            nextButtonAdditionalCssClass={``}
         />
      
      
      </div>
   )
}